import { reviewsWithPhotosCountAtom } from '@components/reviews/atoms';
import { useTrackReviewInteraction } from '@components/reviews/components/search-sort-filter/hooks/use-track-review-interaction';
import { isInReviewPhotoFilterExperiment } from '@redux/experiments/selectors/review-photo-filter';
import { useAppSelector } from '@redux/hooks';
import { useAtomValue, useSetAtom } from 'jotai';
import React from 'react';
import {
	fetchReviewsAtom,
	hasPhotosAtom,
	searchSortFilterAtom,
	searchSortFilterReducer,
} from '../atoms';
import { BaseFilterPill } from './base-filter-pill';

/**
 * PhotoFilter - A filter button for reviews that toggles photo-only filtering
 */
const PhotoFilter = () => {
	const isVariant = useAppSelector(isInReviewPhotoFilterExperiment);
	const hasPhotos = useAtomValue(hasPhotosAtom);
	const setSearchSortFilter = useSetAtom(searchSortFilterAtom);
	const setFetchReviews = useSetAtom(fetchReviewsAtom);
	const trackReviewInteraction = useTrackReviewInteraction();
	const reviewsWithPhotosCount = useAtomValue(reviewsWithPhotosCountAtom);

	// Only show the filter pill if user is in the variant group and has photos
	if (!isVariant || reviewsWithPhotosCount === 0) {
		return null;
	}

	const handleClick = () => {
		const newValue = !hasPhotos ? true : undefined;

		setSearchSortFilter((prev) =>
			searchSortFilterReducer(prev, {
				type: 'toggle-photos',
				payload: newValue,
			}),
		);

		setFetchReviews();
		trackReviewInteraction({
			action: 'filter reviews',
			filter_type: 'photos',
		});
	};

	return (
		<BaseFilterPill
			label="Reviews with photos"
			onClick={handleClick}
			isActive={hasPhotos}
			hasSelectedFilters={hasPhotos}
		/>
	);
};

export { PhotoFilter };
